import { Action, Dispatch } from 'redux'
import { setActiveDatesAction, setCurrentDateAction, setCurrentMonthAction } from 'reducks/calendar/actions'

const handleCurrentMonth = (date: Date) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(setCurrentDateAction(date))
    dispatch(setCurrentMonthAction(date))
    dispatch(setActiveDatesAction([]))
  }
}

export default handleCurrentMonth
